import * as PIXI from "pixi.js";
import { EventHandler } from "../../util/event/EventHandler";
import { AbstractView } from "../view/AbstractView";
import { DialogData } from "./data/DialogData";
/**
 * Dialog.ts
 */
export class Dialog extends AbstractView {
    constructor(properties, portraitProperties) {
        super(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
        this.uiProperties = this.uiProperties;
        this.run();
    }
    postCreate() {
        super.postCreate();
        this.eventMode = "none";
    }
    createProperties(properties, portraitProperties) {
        super.createProperties(properties, portraitProperties);
        this.landscapeProperties = properties;
        this.portraitProperties = portraitProperties;
    }
    destroy() {
        super.destroy();
        this.landscapeProperties = null;
        this.portraitProperties = null;
        this.uiProperties = null;
        this.data = null;
        this.completeHandler = null;
    }
    handleClose() {
        if (this.data) {
            this.data.dispose();
        }
        if (this.timeOutHandler) {
            console.log("clearing timeout");
            clearTimeout(this.timeOutHandler);
        }
        this.data = null;
        this.callHandler(this.completeHandler);
    }
    handleConfirm() {
        this.callDataHandler(DialogData.CONFIRM);
        this.handleClose();
    }
    handleCancel() {
        this.callDataHandler(DialogData.CANCEL);
        this.handleClose();
    }
    handleAddToScene() {
        //no-op, override in subclasses if needed
    }
    handleRemoveFromScene() {
        //no-op, override in subclasses if needed
    }
    callDataHandler(key) {
        if (this.data && this.data.hasHandler(key)) {
            let handler = this.data.getHandler(key);
            handler.call();
        }
    }
    update(data) {
        this.data = data;
        let timeout = data && data.getTimeout();
        //if there is a timer, we need to activate it here
        if (timeout > 0) {
            console.log("timeout", timeout);
            this.timeOutHandler = setTimeout(() => {
                this.handleConfirm();
            }, timeout);
        }
    }
    isClass(name) {
        return this.uiProperties.getClassName() == name;
    }
    getClassName() {
        return this.uiProperties.getClassName();
    }
    getClass() {
        return this.uiProperties.getClass();
    }
    isDismissable() {
        return this.uiProperties.isDismissable();
    }
    onComplete(handler, scope) {
        this.completeHandler = new EventHandler(handler, scope);
    }
    getSize() {
        return new PIXI.Point(this.width, this.height);
    }
    autoPosition() {
        const _scale = this.scale.clone();
        this.scale.set(1);
        let dialogSize = new PIXI.Point(this.width, this.height);
        if (this.renderer.isLandscape()) {
            this.scaleLandscape();
        }
        else {
            this.scalePortrait();
        }
        let rendererSize = this.renderer.getGameSize();
        this.position.set(rendererSize.x / 2, rendererSize.y / 2);
        this.pivot.set(dialogSize.x / 2, dialogSize.y / 2);
        this.scale.set(_scale.x, _scale.y);
    }
    handleResize() {
        this.autoPosition();
        super.handleResize();
    }
    handleRotate(event) {
        super.handleRotate(event);
        this.uiProperties = this.uiProperties;
    }
    scaleLandscape() {
        let newScale = new PIXI.Point(1, 1);
        let x = (this.renderer.getWindowSize().x / this.renderer.getHolder().scale.x);
        let viewportWidth = this.renderer.getViewport().width;
        let minScale = this.renderer.getMinimumScale();
        if (x < viewportWidth) {
            let scale = Math.max(minScale, x / viewportWidth);
            scale = parseFloat(scale.toFixed(2));
            newScale = new PIXI.Point(scale, scale);
        }
        this.scale.copyFrom(newScale);
    }
    scalePortrait() {
        let newScale = new PIXI.Point(1, 1);
        let y = (this.renderer.getWindowSize().y / this.renderer.getHolder().scale.y);
        let viewportHeight = this.renderer.getViewport().height;
        let minScale = 0.6;
        if (y < viewportHeight) {
            let scale = Math.max(minScale, y / viewportHeight);
            scale = parseFloat(scale.toFixed(2));
            newScale = new PIXI.Point(scale, scale);
        }
        this.scale.copyFrom(newScale);
    }
}
//# sourceMappingURL=Dialog.js.map